<template>
  <div :style="iconStyle" />
</template>

<script setup>
import { computed } from 'vue'
import { svgMask } from '@/utils/svg.js'

const props = defineProps({
  name: { type: String, required: true },
  color: { type: String, default: 'currentColor' },
  size: { type: String, default: '24px' }
})

const iconStyle = computed(() => ({
  ...svgMask(`/img/icons/${props.name}.svg`, props.color),
  display: 'inline-block',
  width: props.size,
  height: props.size,
  verticalAlign: 'middle',
}))
</script>
